import React, { Component } from 'react';
import { Modal, Toast } from 'antd-mobile';
import PropTypes from 'prop-types';
import styles from '../liveLogin/style.module.less';
import SendVRCode from '../../../components/sendVRCode';
import { checkCode } from '../../../service/chat-service';

const propTypes = {
  liveDetail: PropTypes.shape({
    streamName: PropTypes.string,
  }),
  isRecord: PropTypes.number,
  liveId: PropTypes.number,
  liveType: PropTypes.number,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  shareUserId: PropTypes.string,
};
const defaultProps = {
  liveDetail: {},
  isRecord: 0,
  liveId: 0,
  liveType: 0,
  shareUserId: '',
};

class LoginModule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: undefined,
      qcode: undefined,
    };
  }

  handleChange = (key) => (event) => {
    const { value } = event.target;
    this.setState({ [key]: value });
  }

  handleMobileLogin = async () => {
    const { mobile, qcode } = this.state;
    const {
      liveDetail, isRecord, liveId, liveType, history, shareUserId,
    } = this.props;
    if (!mobile) return Toast.show('请填写手机号');
    if (mobile.length !== 11) return Toast.show('手机号格式不正确');
    if (!qcode) return Toast.show('请填写验证码');
    try {
      const { code, message } = await checkCode('live', mobile, qcode);
      if (code === 10000) {
        if (liveType === 1) {
          history.push(
            `/liveRegistration?streamName=${liveDetail.streamName}
&liveId=${liveId}&isRecord=${isRecord}&mobile=${mobile}&shareUserId=${shareUserId}`, // 直播
          );
        }
      } else {
        Toast.show(message);
      }
    } catch (e) {
      // console.log(e);
    }
    return false;
  }

  render() {
    const { mobile, code } = this.state;
    return (
      <div>
        <Modal popup visible className={styles.popupLiveLogin} animationType="slide-up">
          <div className={styles.contentBox}>
            <div className={styles.inputBox}>
              <input
                maxLength={11}
                type="text"
                onBlur={this.scrollPosition}
                placeholder="请输入手机号"
                onChange={this.handleChange('mobile')}
                value={mobile}
              />
            </div>
            <div className={styles.inputBox}>
              <input
                type="text"
                maxLength={6}
                placeholder="验证码"
                onBlur={this.scrollPosition}
                onChange={this.handleChange('qcode')}
                value={code}
              />
              <div className={styles.right}>
                <SendVRCode type="live" phoneNumber={mobile} className={styles.sendCode} />
              </div>
            </div>
            <div className={styles.button} onClick={this.handleMobileLogin} role="button" tabIndex={0}>
              进入直播间
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

LoginModule.propTypes = propTypes;
LoginModule.defaultProps = defaultProps;

export default LoginModule;
